import apiKomisi from '@/api/vo-general/komisi';

const defaultState = () => ({
	summaryKomisi: {},
	potency: {},
	summaryTransfer: {},

	listDetailUnilevel: [],
	detailUnilevelPagination: '',

	listHistoryKomisi: [],
	historyKomisiPagination: '',

	listHistoryROCashback: [],
	historyROCashbackPagination: '',

	listHistoryROPeringkat: [],
	historyROPeringkatPagination: '',

	listHistoryTransfer: [],
	historyTransferPagination: '',
	historyTransferDetail: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSummaryKomisi(state, data) {
		state.summaryKomisi = data
	},
	setSummaryTransfer(state, data) {
		state.summaryTransfer = data
	},
	setPotencyKomisi(state, data) {
		state.potency = data
	},
	setListDetailUnilevel(state, data) {
		state.listDetailUnilevel = data.results;
		state.detailUnilevelPagination = data.pagination;
	},
	setHistoryKomisi(state, data) {
		state.listHistoryKomisi = data.results;
		state.historyKomisiPagination = data.pagination;
	},
	setHistoryTranfer(state, data) {
		state.listHistoryTransfer = data.results;
		state.historyTransferPagination = data.pagination;
	},
	setHistoryROCashback(state, data) {
		state.listHistoryROCashback = data.results;
		state.historyROCashbackPagination = data.pagination;
	},
	setHistoryROPeringkat(state, data) {
		state.listHistoryROPeringkat = data.results;
		state.historyROPeringkatPagination = data.pagination;
	},
	setHistoryTransferDetail(state, data) {
		state.historyTransferDetail = data.results;
	},
};

const actions = {
	getSummaryKomisi({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getSummaryKomisi(params).then((results) => {
				const data = results.data
					commit('setSummaryKomisi', data.data.results);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSummaryTransfer({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getSummaryTransfer(params).then((results) => {
				const data = results.data
					commit('setSummaryTransfer', data.data.results);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getPotencyKomisi({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getPotencyKomisi(params).then((results) => {
				const data = results.data
					commit('setPotencyKomisi', data.data.results);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryKomisi({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getHistoryKomisi(params).then((results) => {
				const data = results.data.data
					commit('setHistoryKomisi', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getDetailUnilevel({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getDetailUnilevel(params).then((results) => {
				const data = results.data.data
					commit('setListDetailUnilevel', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryTransfer({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getHistoryTransfer(params).then((results) => {
				const data = results.data.data
					commit('setHistoryTranfer', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getDetailROCashback({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getDetailROCashback(params).then((results) => {
				const data = results.data.data
					commit('setHistoryROCashback', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getDetailROPeringkat({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getDetailROPeringkat(params).then((results) => {
				const data = results.data.data
					commit('setHistoryROPeringkat', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getHistoryTransferDetail({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getHistoryTransferDetail(params).then((results) => {
				const data = results.data.data
					commit('setHistoryTransferDetail', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};